module.exports = __webpack_public_path__ + "img/image 24.ac3191ce.png";